// extracted by mini-css-extract-plugin
export default {"button":"dcc_fastConfigurationButton-button"};